<template>
  <div class="OperatingInstructions">
    <!-- <PublicTitle @back-call="backPath" :title="pageTitle" /> -->
    <div class="hearderBox">
      <span @click="backPath">
        <Svgs name="iconfanhui" color="#000" />
      </span>
      {{ pageTitle }}
    </div>
    <div
      :class="[
        'OperatingInstructionsContent',
        isType == 'trainingMaterials' && 'rocheOperatingInstruction',
      ]"
    >
      <Field :fieldList="fieldList" @call-back="fieldCall"></Field>

      <Skeleton v-if="isFirst" :skList="skList"></Skeleton>
    </div>
  </div>
</template>

<script>
let type = "";
export default {
  name: "OperatingInstructions",
  beforeRouteEnter(to, from, next) {
    console.log(to, from, next);
    type = to.name;
    next();
    // next("/" + roterPath);
    // return;
  },
  components: {},
  data() {
    return {
      isType: type,
      navBackgroundColor: {
        lilly: "#D7290F",
        roche: "#2e82ef",
        novartis: "#0099FF",
        pfizer: "#E60012",
        ipsen: "#224a81",
        msd: "#21BDB0",
        dsm: "#00A16D",
        dscl: "#00b4ed",
      },
      pageTitle: "培训资料",
      isFirst: true,
      fieldList: [],
      skList: [
        {
          width: "100%",
          height: ".2rem",
          mt: ".3rem",
        },
        {
          width: "100%",
          height: ".2rem",
          mt: ".3rem",
        },
        {
          width: "100%",
          height: ".2rem",
          mt: ".3rem",
        },
        {
          width: "100%",
          height: ".2rem",
          mt: ".3rem",
        },
        {
          width: "100%",
          height: ".2rem",
          mt: ".3rem",
        },
        {
          width: "100%",
          height: ".2rem",
          mt: ".3rem",
        },
      ],
    };
  },
  computed: {
    // 会引擎
    needTenantId() {
      let tenant = this.$cookies.get("tenant") || "";
      return tenant == "crossevent";
    },
  },
  created() {
    this.pageTitle = type == "policies" ? "相关政策" : "培训资料";
    this.getCustomerServiceInfo();
  },
  methods: {
    async getCustomerServiceInfo() {
      let tenant =
        this.$cookies.get("tenant") ||
        this.$cookies.get("tenant_code") ||
        this.$iStorage.get("tenant");
      const params = {
        collection: "cfg-ihelper-operating-instructions",
        filter: {
          tenantCode: tenant,
          type: type,
        },
      };
      // 会引擎
      if (this.needTenantId) {
        params.filter.tenantId = this.$cookies.get("tenant_id");
      }
      let _this = this;
      this.services.GetSettings(params).then(function (res) {
        if (res.success) {
          _this.isFirst = false;
          _this.fieldList = res.content.options;
        }
      });
    },

    fieldCall(data) {
      let tenant = this.$cookies.get("tenant");
      let container =
        this.$cookies.get("container") || sessionStorage.getItem("container");
      if (data.callBack == "trainingMaterials") {
        switch (container) {
          case "browser":
          case "h5":
            console.log("====文件信息", data);
            this.$router.push({
              path: "/iframePage",
              query: {
                urlPath: data.path,
              },
            });
            //  window.open(process.env.VUE_APP_PDFVIEWER+"?file="+encodeURIComponent(data.path));
            break;
          case "native":
          default:
            if (window.flutter_inappwebview) {
              window.flutter_inappwebview.callHandler(
                "App.openPdf",
                data.appPath
              );
            } else {
              this.iJsBridge.call({
                method: "SMGeneral.openNewWebSite",
                postData: {
                  loadUrl: data.appPath,
                  browserMode: {
                    navBarVisibilty: true,
                    titleTextColor: "#ffffff",
                    navBackgroundColor: this.navBackgroundColor[tenant],
                  },
                },
              });
            }

            break;
        }
      }
      // switch (data.callBack) {
      //   case "trainingMaterials": //培训资料
      //     this.iJsBridge.call({
      //       method: "SMGeneral.openNewWebSite",
      //       postData: {
      //         loadUrl: data.path,
      //         browserMode: {
      //           navBarVisibilty: true,
      //           titleTextColor: "#ffffff",
      //           navBackgroundColor: this.navBackgroundColor[tenant],
      //         },
      //       },
      //     });
      //     // this.$router.push({
      //     //     name: 'PDFViewer',
      //     //     params: {
      //     //         itemInfo: data
      //     //     }
      //     // })
      //     break;
      //   default:
      //     break;
      // }
    },
    backPath() {
      this.iJsBridge.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.OperatingInstructions {
  // padding-top: 1rem;
  .OperatingInstructionsContent {
    padding: 0.26rem 0;
  }
}
</style>
